import { InputLabel, TextField, Typography } from '@mui/material'
import React from 'react'

const CustomInput = ({value, label, onChange, fullWidth, type, error, helperText, id }) => {
  return (
    <>
      <Typography
  
        sx={{
          color: "#000",
          fontSize: { lg: "14px", md: "14px", sm: "12px", xs: "12px" },
          fontWeight: 500,
        }}
      >
        {label}
      </Typography>
      <TextField
      name={id}
      error={error}
      id={id}
      helperText={helperText}
        size="small"
        type={type}
        value={value}
        onChange={onChange}
        fullWidth={fullWidth}
        margin="dense"
        inputProps={{
          style: {
            fontFamily: "open sans",
            fontSize: "14px",
          },
        }}
      />
    </>
  );
}

export default CustomInput